
<div class="pink_box"></div>
<div class="green_box"></div>

<div class="main">
  <div class="reference_table">
    <div class="top">

      <div class="right_part">
        <form [formGroup]="clusterCommunityForm">
        <div class="row ">

           <div class="col-md-4">
            <mat-form-field class="full-width-field" id="id_number">
              <mat-label>Select Cluster</mat-label>
              <mat-select formControlName="ClusterId" (selectionChange)="selectCluster($event.value)">
                <mat-option>-- None --</mat-option>
                <mat-optgroup *ngFor="let level1 of projectCategories" [label]="level1.ProjectCategoryName"
                              >
                  <mat-option *ngFor="let level3 of level1.clusters" [value]="level3.id">
                    {{level3.ClusterName}}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
           </div>

           <div class="col-md-3" *ngIf="status">
            <mat-form-field class="full-width-field" id="id_number">
              <mat-label>Select Lga</mat-label>
              <mat-select formControlName="LgaId" (selectionChange)="selectedLga($event.value)">
                <mat-option>-- None --</mat-option>
                <mat-optgroup *ngFor="let level1 of states" [label]="level1.StateName"
                              >
                  <mat-option *ngFor="let level3 of level1.lgas" [value]="level3.id">
                    {{level3.LgaName}}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
            </mat-form-field>
           </div>

           <div class="col-md-3" *ngIf="status">

            <mat-form-field class="full-width-field" id="id_number">
              <mat-select placeholder="Select community"  formControlName="CommunityId" (selectionChange)="selectedComm()">
              <mat-option *ngFor="let community of filteredCommunity" [value]="community.id">{{community.CommunityName}}</mat-option>
              </mat-select>
              <!-- <mat-error *ngIf="errorHandling('InstitutionCommunityBeforeAward', 'required')">
                You must provide <strong>Institution community before award</strong>
             </mat-error> -->
              </mat-form-field>

           </div>

           <div class="col-md-2 " *ngIf="showAdd">
            <div class="submit" >
              <button
               mat-raised-button
                (click)="onSubmit(clusterCommunityForm.value)"
                [disabled]="clusterCommunityForm.invalid"
              >
                Add Community
              </button>
            </div>
           </div>
        </div>

      </form>
      </div>

    </div>
<!-- <pre>{{projectCategories | json}}</pre> -->
    <div class="the_edited_cluster" *ngIf="status">
        <div class="thead">
          <span class="head">S/N</span>
          <span class="head">Cluster Community Name</span>
          <span class="head">Action</span>
        </div>

        <div class="tbody" >
          <div
            class="td"
            *ngFor="
              let clusterCommunity of clusterCommunityArrayForm.get('ClusterCommunities')['controls'];
              index as i
            "

          >
            <span class="head">{{ i + 1 }}</span>
            <span
              >{{getCommunityName(clusterCommunity.value.CommunityId)}}
              </span>
            <span
              ><button
                class="delete_icon trash"
                (click)="deleteCluster(i, clusterCommunity.value)"
              >
                <em class="ti-trash"> </em> </button
            ></span>
          </div>

          <div class="submit" >
            <button
              class="submit_button"
            (click)="saveClusterCommunity()"
            >
              Submit
            </button>
          </div>
        </div>

    </div>
  </div>
</div>
